"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/CXFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_56)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_56`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6.95996 0H29.04V24H-6.95996V0Z",
					fill: "#0021AD"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6.95996 0H29.04V24",
					fill: "#1C8A42"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.51433 19.0878L-1.11433 19.9228L-0.216085 19.7123L-0.616085 20.5474L0.106722 21.1158L-0.791523 21.3193V22.2457L-1.51433 21.6632L-2.23012 22.2457V21.3193L-3.12837 21.1158L-2.40556 20.5474L-2.81258 19.7123L-1.90731 19.9228L-1.51433 19.0878ZM-4.11784 12.1474L-3.71784 12.9825L-2.81959 12.772L-3.21959 13.6L-2.49679 14.1755L-3.40205 14.379L-3.39503 15.3053L-4.11784 14.7228L-4.84065 15.3053L-4.83363 14.379L-5.73889 14.1755L-5.00907 13.6L-5.41608 12.772L-4.51784 12.9825L-4.11784 12.1474ZM-1.51433 6.47021L-1.11433 7.29829L-0.216085 7.09478L-0.616085 7.92285L0.106722 8.49829L-0.791523 8.70179V9.62109L-1.51433 9.04565L-2.23012 9.62109V8.70179L-3.12837 8.49829L-2.40556 7.92285L-2.81258 7.09478L-1.90731 7.29829L-1.51433 6.47021ZM1.72076 10.8843L2.12076 11.7193L3.019 11.5088L2.619 12.3439L3.34181 12.9123L2.44356 13.1158V14.0421L1.72076 13.4667L1.00497 14.0421V13.1158L0.106722 12.9123L0.829529 12.3439L0.42953 11.5088L1.32778 11.7193L1.72076 10.8843ZM-0.588014 14.6737L-0.279243 15.6351H0.738301L-0.0827513 16.2316L0.233038 17.193L-0.588014 16.6035L-1.40907 17.193L-1.09328 16.2316L-1.91433 15.6351H-0.903804L-0.588014 14.6737Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.7839 17.2071C14.6712 17.2071 17.0119 14.8664 17.0119 11.979C17.0119 9.09166 14.6712 6.75098 11.7839 6.75098C8.89647 6.75098 6.55579 9.09166 6.55579 11.979C6.55579 14.8664 8.89647 17.2071 11.7839 17.2071Z",
					fill: "#FFC639"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.7839 15.4596H13.5243C13.5243 15.4596 14.2822 14.1263 13.5243 12.8491L15.2646 11.1088L14.3944 9.36841H13.5243C13.5243 9.36841 13.0892 10.6737 11.3488 10.6737C9.60849 10.6737 9.1734 9.36841 9.1734 9.36841H8.30322L9.1734 11.1088L8.30322 12.8491L9.1734 13.7193C9.1734 13.7193 10.0436 11.9789 11.7839 12.8491C11.7839 12.8491 12.5208 13.9368 11.7839 15.4596Z",
					fill: "#1C8A42"
				}),
				/* @__PURE__ */ n("path", {
					d: "M25.6295 6.4702C25.6716 6.26669 25.6155 5.23511 25.6155 5.01756C25.6155 3.52283 24.6401 2.25265 23.2857 1.81055C23.6997 2.65265 23.9313 3.593 23.9313 4.59651C23.9313 4.93335 23.9032 5.26318 23.8541 5.58599C23.6506 5.25616 23.3909 4.96142 23.0681 4.70178C21.8681 3.74739 20.219 3.71932 19.005 4.52634C19.9453 4.72985 20.8506 5.1509 21.6506 5.78949C22.2822 6.28774 22.7874 6.96844 23.1734 7.62107C23.1734 7.62107 21.9243 8.38598 20.998 8.68072C20.0716 8.97546 18.0295 9.23511 18.0295 9.23511C23.0822 10.0772 27.2927 6.70879 27.2927 6.70879C26.8366 5.76844 26.1839 6.42809 25.6295 6.4702Z",
					fill: "#FFC639"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_56`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as CXFlag };
